/**
 * A Shopify variant, plus what its bundle says about availability.
 *
 * Input shape is the API's: `variant.components` is the list of components the
 * variant is made of, each carrying its bundle quantity on `pivot`, its
 * `component_category`, its `invlevels` and its `holds`.
 */
export const getAugmentedVariant = (variant, locationId = 1) => {
    // Component categories used for global available quantity
    const componentsAvailableCategories = [
        'strap',
        'watch_head',
        'watchroll',
        'buckle',
        'back',
    ]

    // Set various data on components
    const components = (variant.components ?? [])
        .map((component) => {
            const full_name_fr =
                component.component_category?.name_fr + ' — ' + component.name

            // Get quantity available at location (return null if component is not listed for this location)
            const physicalAtLocation =
                component.invlevels?.find(
                    (iv) =>
                        iv.invtype === 'physical' &&
                        iv.location_id === locationId
                )?.invlevel ?? null

            // Get holds for this component at this location
            const holdAtLocation =
                component.holds?.find((h) => h.location_id === locationId)
                    ?.hold_quantity ?? 0

            // Get available quantity at location (null if not stocked here)
            const availableAtLocation =
                physicalAtLocation !== null
                    ? physicalAtLocation - holdAtLocation
                    : null

            // Check if it is a global available category
            const isAvailableCategory = componentsAvailableCategories.includes(
                component.category
            )

            return {
                ...component,
                full_name_fr,
                physicalAtLocation,
                holdAtLocation,
                availableAtLocation,
                isAvailableCategory,
            }
        })
        .sort((a, b) => a.full_name_fr.localeCompare(b.full_name_fr))

    // Dispatch date
    const dispatch_date = components
        .filter((c) => c.dispatch_date)
        .map((c) => c.dispatch_date)
        .reduce((a, b) => (a > b ? a : b), null)

    const availablesAtLocationLevels = components
        .filter((p) => p.isAvailableCategory && p.availableAtLocation)
        .map((p) => p.availableAtLocation)

    const availableAtLocation = Math.min(...availablesAtLocationLevels)

    // Shopify behavior
    let is_selling_in_shopify =
        variant.inventory_policy === 'CONTINUE' ||
        variant.quantity_available > 0

    // Check if the variant as a component that is as b2b disallowed
    const isB2BDisallowed = components.some(
        (c) => c.is_b2b_disallowed === true
    )

    return {
        ...variant,
        components,
        dispatch_date,
        availableAtLocation,
        is_selling_in_shopify,
        isB2BDisallowed,
    }
}
